export async function ErrorHandling(result) {

    console.log('response', result);

    // Some talos endpoints (e.g. UpdatePlant) return a 200 with no body at all,
    // so `.json()` would throw a parse error on those — read as text first and
    // tolerate an empty/non-JSON body instead of assuming every response has one.
    let resultJSON = null
    try {
        const text = await result.text()
        resultJSON = text ? JSON.parse(text) : null
    } catch (error) {
        resultJSON = null
    }

    if (result.status === 403 && resultJSON?.message !== 'invalid_credentials') return sendToLogin

    if (result.status !== 200) return { success: false, response: resultJSON?.message, status: 400 }

    if (!resultJSON) return { success: true, response: 'Updated!', status: 200 }

    return { success: true, response: resultJSON, status: 200 }
}

const sendToLogin = {
    success: false,
    response: "throwBack"
}


export const errorFactory = (error) => {

    // For checking internet connection
    if (!window.navigator.onLine) return { success: false, response: "Request failed! Please make sure you have a stable internet connection!" }

    // Normal error message
    return { success: false, response: error.message }
}

const errors = {
    403: {
        success: false,
        response: "throwBack"
    },
}